import * as React from 'react'
import styled from 'styled-components'
import ListItem, {ListItemProps} from '@mui/material/ListItem'
import ListItemText, {ListItemTextProps} from '@mui/material/ListItemText'
import ListItemAvatar, {ListItemAvatarProps} from '@mui/material/ListItemAvatar'
import Avatar, {AvatarProps} from '@mui/material/Avatar'
import ImageIcon from '@mui/icons-material/Image'

export const ListItemAvatarAtom = styled((props: ListItemAvatarProps) => (
  <ListItemAvatar {...props} />
))``
export const ListItemTextAtom = styled((props: ListItemTextProps) => (
  <ListItemText {...props} />
))``
export const AvatarAtom = styled((props: AvatarProps) => (
  <Avatar {...props} />
))``

const ListItemAtom = styled((props: ListItemProps) => (
  <ListItem {...props}>
    <ListItemAvatarAtom>
      <AvatarAtom variant="square">
        <ImageIcon />
      </AvatarAtom>
    </ListItemAvatarAtom>
    <ListItemTextAtom primary="Product Name" secondary="Details of Product" />
  </ListItem>
))``

export default ListItemAtom
